import React from "react"
import styled from "styled-components"
import { Button as BTButton } from "react-bootstrap"
import Modal from "../../../_components/Modal"
import LoadingInput from "../../../_components/LoadingInput"
import Button from "../../../_components/Button"
import { formatPhoneNumber, supportPhoneNumber } from "../../../utils"
import { getCodeToResetPassword, resetPassword, getCodeToResetPasswordViaPhone } from "../../../api/users"
import LoadingButton from "../../../_components/LoadingButton"
/*

    Modal 1 - Informar o email
    Modal 2 - Informar se o email existe, informa 

*/
const Wrapper = styled.p`
    display: flex
    flex-direction: row
    justify-content: space-between

    @media (max-width: 700px){
        flex-direction: column
        text-alig: center
        alig-self: center
        margin-top: 10px
    }
`

const Span = styled.span`
    font-weight: bold
    font-size: 1.2em
`
const SpanClick = styled.span`
    font-weight: bold
    font-size: 1.2em
    color: #094ce5
    cursor: pointer
`

export default props => {
    const [email, setEmail] = React.useState("")
    const [phoneNumber, setPhoneNumber] = React.useState("")
    const [modelChangePassword, setModalChangePassword] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [showModal, ShowModal] = React.useState(false)
    const [modal, setShowModal] = React.useState(false)
    const [phoneModal, setShowPhoneModal] = React.useState(false)
    const [typeModal, setShowTypeModal] = React.useState(false)
    const [title, setTitle] = React.useState("")
    const [description, setDescription] = React.useState("")
    const [data, setData] = React.useState({})
    const [enableButtonChangePassword, setButtonEnablePasswordStatus] = React.useState(false)
    const [componentType, setComponentType] = React.useState(false)
    const [emailDisabled, setEmailDisabled] = React.useState(false)
    const [phoneDisabled, setPhoneDisabled] = React.useState(false)

    const handlePhoneChange = (e) => {
        const value = e.target.value;
        setPhoneNumber(value);

        if (value) {
            setEmail(''); 
            setEmailDisabled(true); 
        } else {
            setEmailDisabled(false)
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        if (value) {
            setPhoneNumber(''); 
            setPhoneDisabled(true); 
        } else {
            setPhoneDisabled(false)
        }
    };

    function closeModal() {
        ShowModal(false)
    }
    function openModal() {
        ShowModal(true)
    }

    function closeTypeModal() {
        setShowTypeModal(false)
    }
    function openTypeModal() {
        setShowTypeModal(true)
    }

    function closePhoneModal() {
        setShowPhoneModal(false)
    }
    function openPhoneModal() {
        setShowPhoneModal(true)
    }

    async function onClick() {
        setLoading(true)

        const formatPhoneNumber = (phone) => {
            return phone.replace(/[^\d]/g, "")
                .replace(/^55/, "")
        }

        let contactInfo = email || phoneNumber

        if (phoneNumber) {
            contactInfo = formatPhoneNumber(phoneNumber)
        }

        if (!contactInfo) {
            setLoading(false)
            setTitle("Ops...")
            setDescription("Por favor, forneça um email ou um número de telefone válido.")
            setShowModal(true)
            return
        }

        await getCodeToResetPassword(contactInfo)
            .then(resp => {
                if (resp.data.code) {
                    try {
                        const h1 = document.createElement('h1')
                        h1.style.display = "none"
                        h1.textContent = resp.data.code
                        h1.id = "reset-code"
                        document.body.appendChild(h1)
                    } catch (error) { }
                }
                resetState()
                setTitle("Solicitação enviada")

                if (email) {
                    setDescription(`As instruções para redefinição de senha foram enviadas para o email ${email}. Verifique sua caixa de spam.`)
                } else if (phoneNumber) {
                    setDescription(`O link de redefinição de senha foi enviado para o telefone ${phoneNumber} via whatsapp.`)
                }

                setShowModal(true)
            })
            .catch(error => {
                resetState()
                setTitle("Ops...")

                if (email) {
                    setDescription("Este não é um email válido!")
                } else if (phoneNumber) {
                    setDescription("Este não é um telefone válido!")
                }

                if (error.response) {
                    const { data } = error.response

                    if (data.not_found === "User not found with the provided email or phone number.") {
                        if (email) {
                            setDescription(`O email ${email} não foi localizado.`)
                        } else if (phoneNumber) {
                            setDescription(`O telefone ${phoneNumber} não foi localizado.`)
                        }
                    }

                    if (data.email) {
                        setDescription("Este não é um email válido!")
                    } else if (data.error) {
                        setDescription("Ocorreu um erro inesperado. Por favor, tente novamente.")
                    }
                }
                setShowModal(true)
            })
            .finally(() => {
                setLoading(false)
            })
    }



    function onCloseModalResult() {
        setShowModal(false)
        setTitle("")
        setDescription("")
    }
    function resetState() {
        closeModal()
        setEmail("")
        setPhoneNumber("")
        setLoading(false)
    }
    function verifyCodeInURL() {

        if (props.componentType) {
            setComponentType(true)
        }

        if (window.location.search.includes("reset-password-code")) {
            const code = window.location.search.split("reset-password-code=")[1]
            setData({ ...data, code })
            setModalChangePassword(true)
        }
    }
    async function onRequestChangePassword() {
        setLoading(true)
        document.getElementById("change-password-feedback-text").textContent = ""
        await resetPassword(data)
            .then(() => {
                setModalChangePassword(false)
                setTitle("Senha atualizada")
                setDescription("As credenciais de acesso foram atualizadas")
                setShowModal(true)
                setTimeout(() => {
                    window.location.href = "/"
                }, 5000)
            })
            .catch(error => {
                setLoading(false)
                let errorMsg = "Não foi possível finalizar a operação. Por favor tente novamente."
                if (error.response) {
                    const { data } = error.response
                    if (data.code_error) {
                        errorMsg = "O código não é valido, por favor informe o email correto"
                    }
                }
                document.getElementById("change-password-feedback-text").textContent = errorMsg
            })
    }
    function onChange(e) {
        const { name: key, value } = e.target
        const newData = { ...data }
        newData[key] = value
        setData(newData)
    }
    function openModalInput() {
        if (props.email) {
            setEmail(props.email)
        }
        setTimeout(() => {
            try { document.getElementById("reset-password-email-input").focus() } catch (error) { }
        }, 100)
    }
    function validate() {
        if (!document.getElementById("change-passwords-feedback-text")) {
            return
        }
        setButtonEnablePasswordStatus(false)
        document.getElementById("change-passwords-feedback-text").textContent = ""
        if (data.password !== data.password2) {
            document.getElementById("change-passwords-feedback-text").textContent = "A senhas são diferentes"
        } else {
            setButtonEnablePasswordStatus(true)
        }
    }
    React.useEffect(verifyCodeInURL, [])
    React.useEffect(openModalInput, [showModal])
    React.useEffect(validate, [data])

    return <React.Fragment>
        {componentType ?
            <div className="row">
                <BTButton disabled={true} variant="outline-danger" className="ml-3 mb-3" style={{ cursor: 'auto' }} onClick={openModal}>
                    <i className="fa fa-exclamation-circle" style={{ color: 'red' }} /> <strong style={{ color: "red" }}>Login ou senha incorretos</strong>
                </BTButton>
                <SpanClick className="ml-3 mb-2" onClick={openPhoneModal} title="Recuperar acesso">
                    Clique aqui para recuperar
                </SpanClick>
            </div>
            :
            <div className="d-flex justify-content-around py-3">
                <Span>
                    Esqueceu sua senha?
                </Span>
                <SpanClick data-cy-test="#span-open-modal-forgot-password" onClick={openPhoneModal} title="Recuperar acesso">
                    Clique aqui para recuperar
                </SpanClick>
            </div>
        }
        {/* main modal */}
        <Modal
            show={showModal}
            data-test="#modal-forgot-password"
            title="Recuperar acesso"
            onHide={closeModal}>
            <div className="form-group">
                <div data-cy-test="#modal-forgot-password-form-label-email" className="form-label">
                    E-mail de acesso
                </div>
                <LoadingInput
                    data-cy-test="#modal-forgot-password-input-email"
                    type="email"
                    name="email"
                    id="reset-password-email-input"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    loading={loading} />
            </div>
            <div className="d-flex justify-content-end">
                <LoadingButton
                    data-cy-test="#modal-forgot-password-button-submit"
                    onClick={onClick}
                    loading={loading}
                    loadingText="Verificando ... "
                    title="Enviar email de recuperação" />
            </div>
        </Modal>
        {/* main modal */}


        {/* phone modal */}

        <Modal
            show={phoneModal}
            data-test="#modal-forgot-password"
            title={
                <span>
                    Recupere sua senha através do seu E-mail ou WhatsApp
                </span>
            }
            onHide={closePhoneModal}>

            <div className="form-group">
                <div data-cy-test="#modal-forgot-password-form-label-email" className="form-label">
                    Digite abaixo seu WhatsApp <i class="fab fa-whatsapp"></i> cadastrado no Easygestor:
                </div>
                <LoadingInput
                    type="phone_number"
                    name="phone"
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    disabled={phoneDisabled}
                    loading={loading} />
            </div>

            <div className="form-group">
                <div data-cy-test="#modal-forgot-password-form-label-email" className="form-label">
                    Digite abaixo seu email cadastrado no Easygestor:
                </div>
                <LoadingInput
                    type="email"
                    name="email"
                    id="reset-password-email-input"
                    value={email}
                    onChange={handleEmailChange}
                    disabled={emailDisabled}
                    loading={loading} />
            </div>
            <div className="d-flex justify-content-center">
                <LoadingButton
                    onClick={onClick}
                    loading={loading}
                    loadingText="Verificando ... "
                    title="Enviar link de recuperação" />
            </div>
            <SpanClick className="d-flex justify-content-center mt-3" onClick={() => { window.open(`https://api.whatsapp.com/send?phone=${supportPhoneNumber}&text=%5BRecuperar%20Senha%20Easygestor%5D%20N%C3%A3o%20lembro%20do%20n%C3%BAmero`) }} title="Não lembro do número">
                Não lembro do número
            </SpanClick>

        </Modal>

        {/* phone modal */}

        {/* type modal */}

        <Modal
            show={typeModal}
            onHide={closeTypeModal}
        >

        </Modal>

        {/* type modal */}


        <Modal
            show={modal}
            title={title}
            onHide={onCloseModalResult}>
            <p className="lead" data-cy-test="#modal-forgot-password-feedback-message">
                {
                    description
                }
            </p>
        </Modal>


        <Modal show={modelChangePassword} title="Redefinir senha" onHide={() => {
            setData({})
            setModalChangePassword(false)
        }}>
            <p id="change-password-feedback-text" data-cy-test="#change-password-feedback-text" className="lead text-danger"></p>
            <div className="form-group">
                <div className="form-label">
                    Informe o E-mail
                </div>
                <LoadingInput
                    name="email"
                    onChange={onChange}
                    loading={loading}
                    type="email"
                    data-cy-test="#modal-change-email"
                />
            </div>
            <div className="form-group">
                <div className="form-label">
                    Informe a nova senha
                </div>
                <LoadingInput
                    name="password"
                    id="input-reset-password-password"
                    data-cy-test="#modal-change-new-password-one"
                    onChange={onChange}
                    loading={loading}
                    type="password"
                />
            </div>
            <div className="form-group">
                <div className="form-label">
                    Confirme a nova senha
                </div>
                <LoadingInput
                    name="password2"
                    data-cy-test="#modal-change-new-password-two"
                    onChange={onChange}
                    loading={loading}
                    type="password"
                />
            </div>
            <p id="change-passwords-feedback-text" className="text-danger"></p>
            <div className="d-flex justify-content-center">
                <LoadingButton
                    onClick={onRequestChangePassword}
                    loading={loading}
                    disabled={!enableButtonChangePassword}
                    loadingText="Verificando ... "
                    data-cy-test="#modal-change-new-password-confirm"
                    title="Recuperar acesso" />
            </div>
        </Modal>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/Auth/ForgotPassword/index.jsx